import { mockTopics } from '@/mocks/homeData';

const colorMap: Record<string, string> = {
  primary: 'bg-primary-100/80 text-primary-700 hover:bg-primary-200/80',
  accent: 'bg-accent-100/80 text-accent-700 hover:bg-accent-200/80',
  secondary: 'bg-secondary-100/80 text-secondary-700 hover:bg-secondary-200/80',
};

export default function TopicsSection() {
  return (
    <section id="topics" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-3">
            热门话题
          </h2>
          <p className="text-sm md:text-base text-foreground-500 max-w-xl mx-auto">
            大家都在讨论的漫画话题，看看有没有你感兴趣的
          </p>
        </div>

        <div className="flex flex-wrap justify-center gap-3 md:gap-4">
          {mockTopics.map((topic, idx) => (
            <div
              key={idx}
              className={`group flex items-center gap-2 px-4 py-2.5 rounded-full cursor-pointer transition-all duration-300 ${colorMap[topic.color]}`}
            >
              <span className="text-sm font-medium whitespace-nowrap">{topic.name}</span>
              <span className="text-xs opacity-70 whitespace-nowrap">{topic.heat}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}